import { AvailableMaps, GoogleMapDisc } from 'types';

type MapConfig = {
  [key in AvailableMaps]: {
    url: string;
    attribution?: string;
  };
};

export const getMapUrl = (mapType: keyof typeof AvailableMaps, language: string) => {
  const isGoogle = [
    AvailableMaps.GoogleHybrid,
    AvailableMaps.GoogleRoadmap,
    AvailableMaps.GoogleSatellite,
  ].includes(mapType as AvailableMaps);
  return `${mapConfig[mapType].url}${isGoogle ? `&hl=${language}` : ''}`;
};

export const mapConfig: MapConfig = {
  GoogleRoadmap: {
    url: `http://mt1.google.com/vt/lyrs=${GoogleMapDisc.Roadmap}&x={x}&y={y}&z={z}`,
  },
  GoogleHybrid: {
    url: `http://mt1.google.com/vt/lyrs=${GoogleMapDisc.Hybrid}&x={x}&y={y}&z={z}`,
  },
  GoogleSatellite: {
    url: `http://mt1.google.com/vt/lyrs=${GoogleMapDisc.SatelliteOnly}&x={x}&y={y}&z={z}`,
  },
  OsmRoadmap: {
    url: `https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  },
  OsmLight: {
    url: `https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png`,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  },
  OsmDark: {
    url: `https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png`,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  },
};
